import React from 'react';
import '../styles/Actualites.css';
import '../styles/Horaires.css';
import Footer from '../components/Footer';

const Actualites = () => {
    return (
        <div className='Actualites'>
            {/* Titre simple sous le header */}
            <div className='horaires-header-simple'>
                <h1 className='horaires-main-title'>Actualités récentes</h1>
                <h2 className='horaires-museum-title'>de l'Amicale de la Gare de Trôo</h2>
                <p className='horaires-main-description'>
                    Suivez toutes nos actualités sur notre page Facebook et restez informés de nos événements
                </p>
            </div>    
            
            
            <div className='FacebookFeedContainer'>
                {/* Intégration Facebook simplifiée avec iframe */}
                <div className='FacebookPluginWrapper'>
                    <div className='FacebookIframeContainer'>
                        <iframe 
                            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FGareDeTroo&tabs=timeline&width=500&height=2400&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                            width="500" 
                            height="2400" 
                            className="absolute top-0 left-0 w-full h-full border-0"
                            style={{
                                border: 'none',
                                overflow: 'hidden',
                                borderRadius: '10px'
                            }}
                            scrolling="no" 
                            frameBorder="0" 
                            allowFullScreen={true}
                            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                            title="Page Facebook Gare de Trôo"
                        ></iframe>
                    </div>
                </div>
                
                <div className='FacebookLinkInfo'>
                    <p>
                        <a 
                            href="https://www.facebook.com/GareDeTroo" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className='FacebookDirectLink'
                        >
                            🔗 Visiter notre page Facebook
                        </a>
                    </p>
                    <p className='FacebookNote'>
                        Rejoignez notre communauté sur Facebook pour ne manquer aucune actualité !
                    </p>
                </div>
            </div>
            
            <div className='ActuFooter'>    
                <Footer />
            </div>
        </div>
    );
};

export default Actualites;